module.exports = __webpack_public_path__ + "assets/76e4b2218018da1f32ef1d52262cb60d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/max_bet.mp3
 ** module id = 323
 ** module chunks = 0
 **/